// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DGly","rootNoMargin":"styles_rootNoMargin__cObb3"};